import { render, staticRenderFns } from "./PresentList.vue?vue&type=template&id=208fc59e&scoped=true&"
import script from "./PresentList.vue?vue&type=script&lang=js&"
export * from "./PresentList.vue?vue&type=script&lang=js&"
import style0 from "./PresentList.vue?vue&type=style&index=0&id=208fc59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208fc59e",
  null
  
)

export default component.exports